import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from 'reactstrap';

const ModalModificarMenuItem = ({ isOpen, toggle, selectedMenuItem, onSave }) => {
    const [formData, setFormData] = useState({
        id: '',
        label: '',
        description: '',
        link: '',
        parent_id: '',
        is_child_item: false,
    });

    useEffect(() => {
        if (selectedMenuItem) {
            setFormData({
                id: selectedMenuItem.id || '',
                label: selectedMenuItem.label || '',
                description: selectedMenuItem.description || '',
                link: selectedMenuItem.link || '',
                parent_id: selectedMenuItem.parent_id || '',
                is_child_item: selectedMenuItem.is_child_item || false,
            });
        }
    }, [selectedMenuItem]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
    };

    const handleSave = () => {
        onSave(formData);
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Modificar Item de Menú</ModalHeader>
            <ModalBody>
                <Form>
                    <FormGroup>
                        <Label for="id">ID</Label>
                        <Input type="text" name="id" id="id" value={formData.id} onChange={handleChange} disabled={true} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="label">Etiqueta</Label>
                        <Input type="text" name="label" id="label" value={formData.label} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="description">Descripción</Label>
                        <Input type="textarea" name="description" id="description" value={formData.description} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="link">Enlace</Label>
                        <Input type="text" name="link" id="link" value={formData.link} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup>
                        <Label for="parent_id">ID Padre</Label>
                        <Input type="text" name="parent_id" id="parent_id" value={formData.parent_id} onChange={handleChange} />
                    </FormGroup>
                    <FormGroup check>
                        <Label check>
                            <Input type="checkbox" name="is_child_item" id="is_child_item" checked={formData.is_child_item} onChange={handleChange} />
                            Es item hijo
                        </Label>
                    </FormGroup>
                </Form>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" onClick={handleSave}>Guardar</Button>
                <Button color="secondary" onClick={toggle}>Cancelar</Button>
            </ModalFooter>
        </Modal>
    );
};

export default ModalModificarMenuItem;